import defineService from "./defineService";
import {setAuthState} from './authorize';

const postInvite = defineService(
  'post', 'api/v1/invite/', {
    alternatives: {dupInvite: '-dup-400'}
  }
);

const putInvite = defineService(
  'put', 'api/v1/invite/'
);

const postAcceptInvite = defineService(
  'post', 'api/v1/invite/:uidtoken/'
);

export async function createAndInviteUser(teamId, email, user_type) {
  var data = {brandly_team: [teamId], email, user_type};
  console.log('createAndInviteUser', data)
  try {
    return await postInvite(data);
  } catch(e) {
    if (e.response && e.response.data) {
      let errors = e.response.data;
      console.log(errors);
      if (errors.email) {
        // Validation error on email. Join all errors (usually only one)
        throw errors.email.join(', ');
      } else if (errors.detail) {
        throw errors.detail;
      } else {
        console.error(e);
        console.log(errors);
        throw 'Error occurred';
      }
    }
    throw e;
  }
}

export async function resendInvite(email) {
  return putInvite({email});
}

export async function acceptInvite(user_id, token, payload) {
  try {
    let data = await postAcceptInvite(user_id + '-' + token, payload);
    return setAuthState(data);
  } catch(e) {
    if (e.response && e.response.data) {
      // Unwrap error
      e = e.response.data;
      if (!e.error) {
        // Some other response...
        console.error(e);
        e.error = 'Error occurred';
      }
    } else {
      // Unknown error. COnvert from error object to string.
      e = {error: ''+e};
    }
    throw e;
  }
}


export function loadInviteData(user_id, token) {
  // TODO check state of invitation
}



// WEBPACK FOOTER //
// ./src/services/invite.js